'use strict';

module.exports = !('0' in [].concat(undefined).concat());